import React from 'react';
import { CSVLink } from 'react-csv';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';

interface Props {
	csvData: any;
	filename: string;
}
export const CSVLinkComponent = (props: Props): React.ReactElement => {
	const { csvData, filename } = props;
	return (
		<div className="text-danger text-end fw-bolder fs-6 csv-link">
			<CSVLink data={csvData} filename={filename}>
				<FontAwesomeIcon icon={faDownload} className="me-2"/>
				Export CSV
			</CSVLink>
		</div>
	);
};
